import React, { useEffect, useRef } from "react";
import "./sky.scss"; // Import the CSS file for styling
const Sky = () => {
  const skyRef = useRef(null);

  const dot = (i, center) => {
    const size = Math.round(Math.random() + 1);
    const root = document.createElement("span");
    root.style.top = center.y + "px";
    root.style.left = center.x + "px";
    root.classList.add("star", `size-${size}`, `axis-${i}`);
    return root;
  };

  const clear = () => {
    if (skyRef.current) {
      skyRef.current.innerHTML = "";
    }
  };

  const init = () => {
    const sky = skyRef.current;
    if (!sky) return;

    const center = {
      x: sky.clientWidth / 2,
      y: sky.clientHeight / 2,
    };

    clear();
    for (let i = 0; i < 360; i++) {
      sky.appendChild(dot(i, center));
    }
  };

  useEffect(() => {
    init();
    // Cleanup function to clear the sky on unmount
    return () => clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div id="sky" ref={skyRef}></div>;
};

export default Sky;
